import React, { useCallback, useEffect, useMemo, useState } from "react";
import CommonAdminTable from "../components/commonTable";
import { Input, Pagination, Typography } from "antd";
import { Link, useLocation } from "wouter";
import { useDispatch, useSelector } from "react-redux";
import { FailedOrdersListAPI } from "../../redux/actions/adminActions/listsAction";
import Alertify from "../../services/alertify";
import { getQueryParams } from "../../utilities/getQueryParams";
import { LoaderIcon } from "react-hot-toast";
const { Title, Text } = Typography;

const FailedOrders = () => {
  useEffect(() => {
    document.title = "Failed Orders: ALP Shop";
  }, []);
  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      key: "index",
      align: "center",
      render: (text, record, index) => (currentPage - 1) * 10 + index + 1,
    },
    {
      title: "Order Id",
      dataIndex: "orderId",
      key: "orderId",
      fixed: "left",
      width: "150px",
      render: (text) => <Link to="#">{text}</Link>,
    },
    {
      title: "Error",
      dataIndex: "error",
      width: "150px",
      key: "error",
      render: (text) => <Text className="text-red-500">{text}</Text>,
    },

    {
      title: "Error Message",
      dataIndex: "errorMessage",
      key: "errorMessage",
      width: "200",
    },
    {
      title: "Placed At",
      dataIndex: "placedAt",
      width: "150px",
      key: "placedAt",
      align: "center",
    },
  ];
  const [searchValue, setSearchValue] = useState("");
  const [totalOrders, setTotalOrders] = useState(0);
  const [loading, setLoading] = useState(true);
  const [, navigate] = useLocation();
  const params = getQueryParams();
  const initialPage = params.page || 1;
  const [currentPage, setCurrentPage] = useState(initialPage);
  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`/admin/failed-orders?page=${page}`);
  };
  const dispatch = useDispatch();

  const fetchFailedOrdersList = useCallback(() => {
    const data = {
      search: searchValue,
      page: currentPage,
    };
    setLoading(true);
    dispatch(FailedOrdersListAPI(data))
      .then((response) => {
        // console.log("List is-----:", response);
        const total = response?.payload?.data?.pagination?.total || 0;
        setTotalOrders(total);
        setLoading(false);

        // console.log("Total orders", total);
      })
      .catch((error) => {
        Alertify.error("Failed to fetch Failed Order List: " + error.message);
        setLoading(false);
      });
  }, [dispatch, searchValue, currentPage]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchFailedOrdersList();
    }, 300); // Delay of 300 milliseconds for debouncing

    return () => {
      clearTimeout(handler);
    };
  }, [fetchFailedOrdersList]);

  const orderRequests = useSelector((state) => state.all_lists);

  const all_orders = useMemo(() => {
    return orderRequests.all_failed_orders_list || [];
  }, [orderRequests]);

  const dataSource = all_orders.map((order, index) => {
    const errorResponse = order?.is_alp_response?.responses[0] || {}; // Ensure response object exists
    const body = errorResponse?.body || {}; // Handle missing body

    return {
      ...order,
      key: order.orderId || index, // Use orderId or index as a fallback key
      error: body.error?.code || "N/A", // Show "N/A" if body or error.code is missing
      errorMessage: body.error?.message || "N/A", // Show "N/A" if body or error.message is missing
    };
  });

  return (
    <>
      <Title level={2} className="text-left pb-4">
        Failed Orders
      </Title>
      <div className="mb-8 flex items-center justify-between max-sm:flex-col max-sm:gap-4">
        <div className="sm:w-1/3">
          <Input
            placeholder="Search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>
      </div>
      {loading ? (
        <div className="flex items-center justify-center pt-60">
          <LoaderIcon className="w-[3vw] h-[3vw] " />
        </div>
      ) : (
        <>
          <CommonAdminTable columns={columns} data={dataSource} />
          <div className="flex justify-between items-center mt-4">
            <Pagination
              current={currentPage}
              total={totalOrders} // Use totalOrders state
              pageSize={10}
              onChange={handlePageChange}
              showSizeChanger={false}
            />
          </div>
        </>
      )}
    </>
  );
};

export default FailedOrders;
